import { render, staticRenderFns } from "./UpdateProdtypeModal.vue?vue&type=template&id=584cc8f8&"
import script from "./UpdateProdtypeModal.vue?vue&type=script&lang=js&"
export * from "./UpdateProdtypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports